var map = {
  "./mobile/index": [
    "61259",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "47149",
    "6532",
    "71882",
    "23690",
    "99268",
    "26476",
    "60146",
    "94720",
    "59508",
    "89834",
    "17348",
    "84259",
    "13983",
    "8566",
    "81417"
  ],
  "./desktop/index.js": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "14398",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "47149",
    "71882",
    "23690",
    "99268",
    "26476",
    "13529",
    "94720",
    "59508",
    "89834",
    "17348",
    "35049",
    "84259",
    "754",
    "23501",
    "85567"
  ],
  "./desktop/index": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "14398",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "47149",
    "71882",
    "23690",
    "99268",
    "26476",
    "13529",
    "94720",
    "59508",
    "89834",
    "17348",
    "35049",
    "84259",
    "754",
    "23501",
    "85567"
  ],
  "./mobile/index.js": [
    "61259",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "47149",
    "6532",
    "71882",
    "23690",
    "99268",
    "26476",
    "60146",
    "94720",
    "59508",
    "89834",
    "17348",
    "84259",
    "13983",
    "8566",
    "81417"
  ],
  "./mobile/LatestNews": [
    "76439",
    9,
    "9598",
    "47387",
    "88565",
    "23690",
    "34334"
  ],
  "./mobile": [
    "61259",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "47149",
    "6532",
    "71882",
    "23690",
    "99268",
    "26476",
    "60146",
    "94720",
    "59508",
    "89834",
    "17348",
    "84259",
    "13983",
    "8566",
    "81417"
  ],
  "./mobile/LatestNews.scss": [
    "22627",
    7,
    "88427"
  ],
  "./desktop": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "14398",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "47149",
    "71882",
    "23690",
    "99268",
    "26476",
    "13529",
    "94720",
    "59508",
    "89834",
    "17348",
    "35049",
    "84259",
    "754",
    "23501",
    "85567"
  ],
  "./desktop/": [
    "15303",
    9,
    "9598",
    "76225",
    "62815",
    "14398",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "47149",
    "71882",
    "23690",
    "99268",
    "26476",
    "13529",
    "94720",
    "59508",
    "89834",
    "17348",
    "35049",
    "84259",
    "754",
    "23501",
    "85567"
  ],
  "./desktop/LatestNews.scss": [
    "44021",
    7,
    "67209"
  ],
  "./desktop/LatestNews.js": [
    "68747",
    9,
    "9598",
    "47387",
    "88565",
    "23690",
    "87376"
  ],
  "./mobile/": [
    "61259",
    9,
    "9598",
    "6850",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "47149",
    "6532",
    "71882",
    "23690",
    "99268",
    "26476",
    "60146",
    "94720",
    "59508",
    "89834",
    "17348",
    "84259",
    "13983",
    "8566",
    "81417"
  ],
  "./desktop/LatestNews": [
    "68747",
    9,
    "9598",
    "47387",
    "88565",
    "23690",
    "87376"
  ],
  "./mobile/LatestNews.js": [
    "76439",
    9,
    "9598",
    "47387",
    "88565",
    "23690",
    "34334"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 96730;
module.exports = __rspack_async_context;
